import type { PressItem } from '../types/content'

export const pressLogos = [
  'FORBES',
  'FINANCIAL TIMES',
  'TECHCRUNCH',
  'BLOOMBERG',
  'VOGUE BUSINESS',
  'QUARTZ',
  'THE ECONOMIST',
  'REST OF WORLD',
  'SIFTED',
  'CNBC AFRICA',
]

export const pressItems: PressItem[] = [
  {
    outlet: 'Forbes',
    title: 'The operators quietly rebuilding Africa’s venture landscape',
    type: 'Feature',
    year: '2026',
  },
  {
    outlet: 'Financial Times',
    title: 'Inside the rise of the operator-investor',
    type: 'Interview',
    year: '2026',
  },
  {
    outlet: 'Vogue Business',
    title: 'Power, patience and the long game of company building',
    type: 'Feature',
    year: '2025',
  },
  {
    outlet: 'The Twenty Minute VC',
    title: 'Building where the infrastructure isn’t',
    type: 'Podcast',
    year: '2025',
  },
  {
    outlet: 'Bloomberg',
    title: 'Blended finance finally finds its founders',
    type: 'Interview',
    year: '2025',
  },
  {
    outlet: 'TechCrunch',
    title: 'The venture studio model comes to West Africa',
    type: 'Feature',
    year: '2024',
  },
  {
    outlet: 'Sifted',
    title: 'Europe’s LPs look south',
    type: 'Interview',
    year: '2024',
  },
  {
    outlet: 'Africa Business Awards',
    title: 'Ecosystem Builder of the Year',
    type: 'Award',
    year: '2024',
  },
  {
    outlet: 'Quartz',
    title: '40 under 40: the architects of the next decade',
    type: 'Award',
    year: '2023',
  },
]
